import { useEffect, useState } from 'react'
import { Button } from '@/components/ui/button'
import { ClientDetailedDto } from 'api/Clients/Types/ClientDetailedDto'
import { PaymentAgentDto } from 'api/Wallet/Types/PaymentAgentDto'
import { FormSelect } from 'components/Form'
import {
  FormBaseButtonContainer,
  FormBaseContainer,
  FormBaseFieldBlock,
  FormBaseFieldGroup,
  FormBaseFieldLabel,
  FormBaseRow,
} from 'components/Form/Form.styles'
import { Option } from 'components/Select'
import { Spinner } from 'components/Spinner'
import { Form, FormikProps, withFormik } from 'formik'
import { useApiClient } from 'utils/api/ApiClient'
import { WalletsApiClient } from 'utils/api/walletsApiClient'

const AddClientPOAForm = (props: MyProps & FormikProps<{ paymentAgentId: null | string }>) => {
  const [isLoading, setLoading] = useState<boolean>(false)
  const [paymentAgents, setPaymentAgents] = useState<PaymentAgentDto[] | null>(null)
  const { submitForm } = props
  const walletsApiClient = useApiClient(WalletsApiClient)

  useEffect(() => {
    const fetchData = async () => {
      try {
        setLoading(true)
        // const query = `TickmillCompanyId == ${props.client.tickmillCompany.id}`
        // const response = await api.getPaymentAgentsQuery(query)

        const response = await walletsApiClient.getPaymentAgentsAll()
        setPaymentAgents(response)
        setLoading(false)
      } catch (error) {
        console.error(error)
        return setLoading(false)
      }
    }
    fetchData()
  }, []) // eslint-disable-line react-hooks/exhaustive-deps

  const save = async () => {
    if (props.values.paymentAgentId) {
      await walletsApiClient.acceptPaymentAgentClientPOA(
        props.values.paymentAgentId,
        props.client.id
      )
    }
    await submitForm()
  }

  if (isLoading || !paymentAgents) {
    return <Spinner />
  }

  return (
    <FormBaseContainer>
      <Form>
        <FormBaseFieldBlock>
          <FormBaseRow>
            <FormBaseFieldLabel>Name</FormBaseFieldLabel>
            <FormBaseFieldGroup>
              <FormSelect name='paymentAgentId' showSearch fullWidth>
                {(paymentAgents || []).map((paymentAgent) => (
                  <Option key={paymentAgent.id} value={paymentAgent.id}>
                    {paymentAgent.name}
                  </Option>
                ))}
              </FormSelect>
            </FormBaseFieldGroup>
          </FormBaseRow>
        </FormBaseFieldBlock>
        <FormBaseButtonContainer>
          <Button type='button' onClick={save} disabled={props.isSubmitting}>
            Submit
          </Button>
        </FormBaseButtonContainer>
      </Form>
    </FormBaseContainer>
  )
}
interface MyFormProps {
  onClose: () => void
  client: ClientDetailedDto
}

type MyProps = MyFormProps

export default withFormik<MyProps, { paymentAgentId: string | null }>({
  mapPropsToValues: () => {
    return {
      paymentAgentId: null,
    }
  },
  handleSubmit: async (_values, { props, setSubmitting }) => {
    setSubmitting(false)
    props.onClose()
  },
})(AddClientPOAForm)
